<template>
  <a
    :href="href"
    class="footer-badge"
    @click.prevent="handleClick"
  >
    <i :class="icon"></i>
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'FooterBadge',
  props: {
    href: {
      type: String,
      default: '#download'
    },
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>
.footer-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #ffffff;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.footer-badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.footer-badge:hover::before {
  left: 100%;
}

.footer-badge:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-4px) scale(1.02);
  color: #ffffff;
  text-decoration: none;
  box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.2),
    0 0 20px rgba(255, 255, 255, 0.1);
}

.footer-badge:active {
  transform: translateY(-2px) scale(0.98);
}

.footer-badge i {
  font-size: 1.3rem;
  transition: all 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.footer-badge:hover i {
  transform: scale(1.15) rotate(5deg);
  filter: drop-shadow(0 4px 8px rgba(255, 255, 255, 0.3));
}

@media (max-width: 768px) {
  .footer-badge {
    flex: 1;
    min-width: 140px;
  }
}

@media (max-width: 576px) {
  .footer-badge {
    width: 100%;
  }
}
</style>

